export const editStoreInfo = [
  {
    path: '/digitalMarketing/editStoreInfo/editStoreInfoList',
    name: 'editStoreInfoList',
    component: () => import('views/digitalMarketing/editStoreInfo/editStoreInfoList'),
    meta: {
      title: '线上店铺设置门店列表'
    }
  },
  {
    path: '/digitalMarketing/editStoreInfo/editBrandInfo',
    name: 'editBrandInfo',
    component: () => import('views/digitalMarketing/editStoreInfo/editBrandInfo'),
    meta: {
      title: '品牌信息'
    }
  },
  {
    path: '/digitalMarketing/editStoreInfo/editStoreInfoEdit',
    name: 'editStoreInfoEdit',
    component: () => import('views/digitalMarketing/editStoreInfo/editStoreInfoEdit'),
    meta: {
      title: '编辑店铺信息'
    }
  },
  {
    path: '/digitalMarketing/editStoreInfo/editTemplateinfo/shopInfoModule',
    name: 'shopInfoModule',
    component: () => import('views/digitalMarketing/editStoreInfo/editTemplateinfo/shopInfoModule'),
    meta: {
      title: '新店铺信息'
    }
  },
  {
    path: '/digitalMarketing/editStoreInfo/storeInfoPreview',
    name: 'storeInfoPreview',
    component: () => import('views/digitalMarketing/editStoreInfo/storeInfoPreview'),
    meta: {
      title: '店铺预览'
    }
  },
  {
    path: '/digitalMarketing/editStoreInfo/editTemplateinfo',
    name: 'editTemplateinfo',
    component: () => import('views/digitalMarketing/editStoreInfo/editTemplateinfo'),
    meta: {
      title: '模版配置'
    }
  },
  {
    path: '/digitalMarketing/editStoreInfo/editTemplateinfo/imageModule',
    name: 'imageModule',
    component: () => import('views/digitalMarketing/editStoreInfo/editTemplateinfo/imageModule'),
    meta: {
      title: '图片模块'
    }
  },
  {
    path: '/digitalMarketing/editStoreInfo/editTemplateinfo/moduleSort',
    name: 'moduleSort',
    component: () => import('views/digitalMarketing/editStoreInfo/editTemplateinfo/moduleSort'),
    meta: {
      title: '模块排序'
    }
  },
  {
    path: '/digitalMarketing/editStoreInfo/editTemplateinfo/menuNavigationModule',
    name: 'menuNavigationModule',
    component: () => import('views/digitalMarketing/editStoreInfo/editTemplateinfo/menuNavigationModule'),
    meta: {
      title: '宫格导航'
    }
  },
  {
    path: '/digitalMarketing/editStoreInfo/editTemplateinfo/menuNavigationModule/chooseMenuNavigationModule',
    name: 'chooseMenuNavigationModule',
    component: () => import('views/digitalMarketing/editStoreInfo/editTemplateinfo/menuNavigationModule/chooseMenuNavigationModule'),
    meta: {
      title: '宫格导航模版选择'
    }
  },
  {
    path: '/digitalMarketing/editStoreInfo/editTemplateinfo/chooseJumpPath',
    name: 'chooseJumpPath',
    component: () => import('views/digitalMarketing/editStoreInfo/editTemplateinfo/chooseJumpPath'),
    meta: {
      title: '跳转路径'
    }
  },
  {
    path: '/digitalMarketing/editStoreInfo/editTemplateinfo/chooseJumpPath/customizePath',
    name: 'customizePath',
    component: () => import('views/digitalMarketing/editStoreInfo/editTemplateinfo/chooseJumpPath/customizePath'),
    meta: {
      title: '自定义链接'
    }
  },
  {
    path: '/digitalMarketing/editStoreInfo/editTemplateinfo/chooseJumpPath/normalGoodsList',
    name: 'normalGoodsList',
    component: () => import('views/digitalMarketing/editStoreInfo/editTemplateinfo/chooseJumpPath/normalGoodsList'),
    meta: {
      title: '普通商品'
    }
  },
  {
    path: '/digitalMarketing/editStoreInfo/editTemplateinfo/chooseJumpPath/limitedTimeActivityList',
    name: 'limitedTimeActivityList',
    component: () => import('views/digitalMarketing/editStoreInfo/editTemplateinfo/chooseJumpPath/limitedTimeActivityList'),
    meta: {
      title: '特价商品'
    }
  },
  {
    path: '/digitalMarketing/editStoreInfo/editTemplateinfo/chooseJumpPath/goodsCategoryList',
    name: 'goodsCategoryList',
    component: () => import('views/digitalMarketing/editStoreInfo/editTemplateinfo/chooseJumpPath/goodsCategoryList'),
    meta: {
      title: '商品分类'
    }
  },
  {
    path: '/digitalMarketing/editStoreInfo/editTemplateinfo/changeTemplate',
    name: 'changeTemplate',
    component: () => import('views/digitalMarketing/editStoreInfo/editTemplateinfo/changeTemplate'),
    meta: {
      title: '更换模版'
    }
  },
  {
    path: '/digitalMarketing/editStoreInfo/editTemplateinfo/goodsModule',
    name: 'goodsModule',
    component: () => import('views/digitalMarketing/editStoreInfo/editTemplateinfo/goodsModule'),
    meta: {
      title: '大家都在抢'
    }
  },
  {
    path: '/digitalMarketing/editStoreInfo/editTemplateinfo/goodsModule/addStoreGoods',
    name: 'addStoreGoods',
    component: () => import('views/digitalMarketing/editStoreInfo/editTemplateinfo/goodsModule/addStoreGoods'),
    meta: {
      title: '添加商品'
    }
  },
  {
    path: '/digitalMarketing/editStoreInfo/editTemplateinfo/goodsModule/searchGoods',
    name: 'searchGoods',
    component: () => import('views/digitalMarketing/editStoreInfo/editTemplateinfo/goodsModule/searchGoods'),
    meta: {
      title: '添加商品'
    }
  }
]
